import React from 'react';
import AppLogoTitleSetting from './components';
import Layout from '../../layouts/index';

const LogoTitleSetting = () => {
    return (
        <Layout>
            <AppLogoTitleSetting />
        </Layout>
    );
};

export default LogoTitleSetting;
